// extracted by mini-css-extract-plugin
export var label = "_d9-1";
export var reminder = "_d9-0";